export function remToPx(value) {
  return Math.round(parseFloat(value) * 16);
}

export function pxToRem(value) {
  return `${value / 16}rem`;
}

export function responsiveFontSizes({ sm, md, lg }) {
  return {
    '@media (min-width:600px)': {
      fontSize: pxToRem(sm),
    },
    '@media (min-width:900px)': {
      fontSize: pxToRem(md),
    },
    '@media (min-width:1200px)': {
      fontSize: pxToRem(lg),
    },
  };
}

const FONT_PRIMARY = 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

const typography = {
  fontFamily: FONT_PRIMARY,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,
  fontWeightBold: 700,
  h1: {
    fontWeight: 700,
    lineHeight: 1.2,
    letterSpacing: '-0.02em',
    fontSize: pxToRem(32),
    ...responsiveFontSizes({ sm: 36, md: 40, lg: 44 }),
  },
  h2: {
    fontWeight: 700,
    lineHeight: 1.25,
    letterSpacing: '-0.02em',
    fontSize: pxToRem(28),
    ...responsiveFontSizes({ sm: 30, md: 32, lg: 36 }),
  },
  h3: {
    fontWeight: 600,
    lineHeight: 1.3,
    letterSpacing: '-0.015em',
    fontSize: pxToRem(22),
    ...responsiveFontSizes({ sm: 24, md: 26, lg: 28 }),
  },
  h4: {
    fontWeight: 600,
    lineHeight: 1.35,
    letterSpacing: '-0.01em',
    fontSize: pxToRem(18),
    ...responsiveFontSizes({ sm: 19, md: 20, lg: 22 }),
  },
  h5: {
    fontWeight: 600,
    lineHeight: 1.4,
    fontSize: pxToRem(16),
    ...responsiveFontSizes({ sm: 17, md: 18, lg: 18 }),
  },
  h6: {
    fontWeight: 600,
    lineHeight: 1.5,
    fontSize: pxToRem(15),
    ...responsiveFontSizes({ sm: 15, md: 16, lg: 16 }),
  },
  subtitle1: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(15),
  },
  subtitle2: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(13),
  },
  body1: {
    fontWeight: 400,
    lineHeight: 1.55,
    fontSize: pxToRem(14),
  },
  body2: {
    fontWeight: 400,
    lineHeight: 1.55,
    fontSize: pxToRem(13),
  },
  caption: {
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
    color: 'inherit',
  },
  overline: {
    fontWeight: 600,
    lineHeight: 1.5,
    fontSize: pxToRem(11),
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
  },
  button: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(14),
    textTransform: 'none',
    letterSpacing: 0,
  },
};

export default typography;
